
// src/components/MainContent/MainContent.tsx
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import SideDrawer, { NavItem } from "../SideDrawer/SideDrawer";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import HelpCenterIcon  from '@mui/icons-material/HelpCenter';
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import ErrorIcon from "@mui/icons-material/Error";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import TuneIcon from "@mui/icons-material/Tune";
import "./MainContent.css";
import {
  getAllowedMenusForRole,
  SidebarMenuId,
} from "../../constants/roleAccess";

type MainContentProps = {
  contentHeight?: number;
  handleMenuItemClick?: (path: string, label: string, item: NavItem) => void;
};

const MainContent: React.FC<MainContentProps> = (props) => {
  const { contentHeight = 0, handleMenuItemClick } = props;
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
  }, [dispatch]);

  let items: NavItem[] = [];

  const currentRole = useSelector(
    (state: any) => state?.userRoles?.currentRole || null,
  );
  const persistedRoleId = sessionStorage.getItem("selectedRoleId");
  const effectiveRole = currentRole || persistedRoleId;
  const isRoleReady = Boolean(effectiveRole);
  const allowedMenus = new Set(
    isRoleReady ? getAllowedMenusForRole(effectiveRole) : [],
  );

  // All possible menus
  const allMenus: Array<NavItem & { menuId: SidebarMenuId }> = [
    { menuId: "SSA Dashboard", label: "SSA Dashboard", path: "/admin/ssa-dashboard", icon: <DashboardIcon /> },
    { menuId: "SSA Control", label: "SSA Control", path: "/admin/ssa-control", icon: <TuneIcon /> },
    { menuId: "Approver Maintenance", label: "Approver Maintenance", path: "/admin/adminView", icon: <ManageAccountsIcon /> },
    {
      menuId: "Data Error",
      label: "Data Error",
      path: "/admin/data-error",
      icon: <ErrorIcon />,
      onClick: () =>
        handleMenuItemClick?.("/admin/data-error", "Data Error", {
          label: "Data Error",
          path: "/admin/data-error",
        }),
    },
    {
      menuId: "Input View",
      label: "Input View",
      path: "/endUserView/input",
      icon: <InputIcon />,
      onClick: () =>
        handleMenuItemClick?.("/endUserView/input", "Input View", {
          label: "Input View",
          path: "/endUserView/input",
        }),
    },
    {
      menuId: "Output View",
      label: "Output View",
      path: "/endUserView/outputView",
      icon: <OutputIcon />,
      onClick: () =>
        handleMenuItemClick?.("/endUserView/outputView", "Output View", {
          label: "Output View",
          path: "/endUserView/outputView",
        }),
    },
    {
      menuId: "Approver",
      label: "Approver",
      path: "/approverView",
      icon: <HowToRegIcon />,
      onClick: () =>
        handleMenuItemClick?.("/approverView", "Approver", {
          label: "Approver",
          path: "/approverView",
        }),
    },
    { menuId: "Support Ticket Summary", label: "Support Ticket Summary", path: "/admin/support-ticket-summary", icon: <HelpCenterIcon  /> },
  ];

  items = allMenus
    .filter((menu) => allowedMenus.has(menu.menuId))
    .map(({ menuId: _menuId, ...rest }) => rest);

  return (
    <div className="main-content">
      {/* Home is fixed-first inside SideDrawer; items follow dynamically */}
      <SideDrawer contentHeight={contentHeight} items={items} homePath="/" />

      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default MainContent;
